import type { NavLink } from '../types-company'

export const primaryNav: NavLink[] = [
  { label: 'Home', to: '/' },
  { label: 'Products', to: '/catalog' },
  { label: 'Crop Solutions', to: '/crop-solutions' },
  { label: 'Knowledge', to: '/knowledge' },
  { label: 'Gallery', to: '/gallery' },
  { label: 'About', to: '/about' },
  { label: 'Contact', to: '/contact' },
]

export const footerNav: { title: string; links: NavLink[] }[] = [
  {
    title: 'Explore',
    links: [
      { label: 'All Products', to: '/catalog' },
      { label: 'Crop Solutions', to: '/crop-solutions' },
      { label: 'Knowledge Base', to: '/knowledge' },
      { label: 'Gallery', to: '/gallery' },
      { label: 'About Us', to: '/about' },
    ],
  },
  {
    title: 'Categories',
    links: [
      { label: 'Soil Biology', to: '/product-categories/soil-biology' },
      { label: 'Soil Improvers', to: '/product-categories/soil-improvers' },
      { label: 'Biostimulants', to: '/product-categories/biostimulants' },
      { label: 'Plant Strength', to: '/product-categories/plant-strength' },
      { label: 'Water Management', to: '/product-categories/water-management' },
    ],
  },
  {
    title: 'Support',
    links: [
      { label: 'Contact', to: '/contact' },
      { label: 'Become a Retailer', to: '/retailer-enquiry' },
      { label: 'Become a Distributor', to: '/distributor-enquiry' },
      { label: 'Data Sheets & Approvals', to: '/resources' },
      { label: 'FAQ', to: '/faq' },
    ],
  },
  {
    title: 'Learn',
    links: [
      { label: 'Soil biology', to: '/knowledge/soil-biology' },
      { label: 'The rhizosphere', to: '/knowledge/rhizosphere' },
      { label: 'Bio-fertilizers', to: '/knowledge/bio-fertilizers' },
      { label: 'Biostimulants', to: '/knowledge/biostimulants' },
      { label: 'Humic & fulvic', to: '/knowledge/humic-and-fulvic-substances' },
      { label: 'Foliar vs soil', to: '/knowledge/foliar-and-soil-application' },
    ],
  },
  {
    title: 'Legal',
    links: [
      { label: 'Privacy Policy', to: '/privacy-policy' },
      { label: 'Terms of Use', to: '/terms' },
      { label: 'Disclaimer', to: '/disclaimer' },
    ],
  },
]
